<template>
  <v-container class="bank-add-page" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "激励添加" : "激励编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='600'
      >
      <template v-slot:content>
        <v-card class="px-4" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md='5'>
                <v-select
                  :rules="required"
                  hide-details="auto"
                  outlined
                  :items="[{ text: '个人绩效', value: 1 },{ text: '部门绩效', value: 2 },{ text: '个人收款', value: 3 }]"
                  label="激励类型"
                  v-model="form.type"
                ></v-select>
              </v-col>
              <v-col cols="12" md='7'>
                <base-material-date
                  hide-details
                  range
                  :rules="required"
                  label='起始-截止时间(多选)'
                  clearable
                  :min="$moment().startOf('month').format('YYYY-MM-DD')"
                  :max="$moment().endOf('month').format('YYYY-MM-DD')"
                  outlined
                  v-model="form.timeRangs"
                  clear-icon="mdi-close-circle-outline"
                >
                </base-material-date>
              </v-col>
            </v-row>
            <div v-if="form.contentList.length > 0" class="my-3">
              <v-row v-for="(item, idx) in form.contentList" :key="idx">
                <v-col cols="12" md='5'>
                  <v-select
                    :rules="required"
                    hide-details="auto"
                    outlined
                    :items="[{ text: '第一名', value: '1' },{ text: '第二名', value: '2' },{ text: '第三名', value: '3' }]"
                    label="排名"
                    v-model="form.contentList[idx].key"
                  ></v-select>
                </v-col>
                <v-col cols="12" md='6'>
                  <v-text-field label="激励金额" :rules="number" hide-details='auto' outlined v-model="form.contentList[idx].value"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="text-right">
                  <v-btn class="my-2 ml-n3" small depressed @click="moveContentList(form.contentList, idx)" :disabled='form.contentList.length <= 1' fab color="primary">
                    <v-icon dark>mdi-minus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-row class="mb-3">
              <v-col cols="12">
                <v-btn block  color="primary" @click="addContentList()" v-if="form.contentList.length < 3" outlined><v-icon>mdi-plus</v-icon>新增激励内容</v-btn>
              </v-col>
            </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/setting/reward.js'

  export default {
    name: 'RewardAdd',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        tab: '',
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        form: {
          id: '',
          type: '',
          content: '',
          contentList: [],
          year: '',
          month: '',
          timeRangs: '',
          startTime: '',
          endTime: ''
        },
        defForm: {
          id: '',
          type: '',
          content: '',
          contentList: [],
          year: '',
          month: '',
          timeRangs: '',
          startTime: '',
          endTime: ''
        },
        content: {
          key: '',
          value: ''
        },
        defContent: {
          key: '',
          value: ''
        }
      }
    },
    methods: {
      moveContentList (item, idx) {
        item.splice(idx, 1)
      },
      addContentList () {
        this.content = JSON.parse(JSON.stringify(this.defContent))
        this.form.contentList.push(this.content)
      },
      save () {
        if (this.$refs.form.validate()) {
          if (this.form.timeRangs.length < 2 || this.form.timeRangs[1] === '') {
            this.$dialog.notify.warning('请选择时间区间', { position: 'top-right', timeout: 4000 })
            return
          }
          this.buildForm()
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      buildForm() {
        this.form.content = JSON.stringify(this.form.contentList)
        this.form.startTime = Number(this.$moment(this.form.timeRangs[0]).valueOf()) / 1000
        this.form.endTime = Number(this.$moment(this.form.timeRangs[1]).valueOf()) / 1000
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.form.contentList.push(this.defContent)
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
